// extracted by mini-css-extract-plugin
module.exports = {"addMatch":"AddMatch_addMatch__3dAaZ","errorMsg":"AddMatch_errorMsg__1vGZu"};